module.exports = __webpack_public_path__ + "183b9add3a8c2a9499b9085a223363d7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/selfie-stick-s.png
// module id = 2732
// module chunks = 0